/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/25/22
 */

import React from "react";
import {Stack, Typography, Button} from "@mui/material";
import HeroImage from "../../media/images/notifications.svg";
import {Link} from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

export default function NoSubscriptions() {

	return (
		<Stack justifyContent={"center"} direction={"column"} alignItems={"center"} spacing={2} sx={{ p: 10 }}>
			<Stack>
				<img src={HeroImage} alt={"No notifications"} style={{width: "100px"}} />
			</Stack>
			<Stack>
				<Typography variant="h5">
					{"You haven't configured any event notifications yet"}
				</Typography>
			</Stack>
			<Stack color="text.secondary">
				<Typography variant="subtitle1">
					{"We can send you a Slack notification when something interesting is happening"}
				</Typography>
			</Stack>
			<Button
				variant={"contained"}
				color={"primary"}
				component={Link}
				to={"/notification/events/new"}
				startIcon={<AddIcon />}
			>
				Create Notification
			</Button>
		</Stack>
	);

}